module.exports = __webpack_public_path__ + "img/Group 28416@2x.867190d5.png";